import { useIsMobileDevice } from '@air/provider-media-query';

import { BrowserUtils } from '~/utils/BrowserUtils';

export const useIsIosMobileDevice = () => {
  const { isMobileDevice } = useIsMobileDevice();

  return { isIosMobileDevice: isMobileDevice && BrowserUtils.isiOS() };
};
